import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  Col,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";
import { AccommodationDetailsBasic } from "./accommodationSlice";
import { getAccommodationTranslationItem } from "../../common/misc";

const AccommodationDesc = ({
  accommodationDetailsBasic,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
}) => {
  let description = getAccommodationTranslationItem(
    "fi_FI",
    "AccommodationDescriptionStart",
    accommodationDetailsBasic,
  );
  description += getAccommodationTranslationItem(
    "fi_FI",
    "AccommodationDescriptionEnd",
    accommodationDetailsBasic,
  );
  return (
    <>
      <div className="border-bottom pb-24 mb-24">
        <h5>Kuvaus</h5>
        <Row xs={1} xl={2} className="g-32">
          <Col>
            <FormLabel> FI</FormLabel>
            <div>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {getAccommodationTranslationItem(
                  "fi_FI",
                  "AccommodationDescriptionStart",
                  accommodationDetailsBasic,
                )}
              </p>
            </div>
          </Col>
          <Col>
            <FormLabel>En</FormLabel>
            <div>
              <p
                style={{ whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{
                  __html: getAccommodationTranslationItem(
                    "en_EN",
                    "AccommodationDescriptionStart",
                    accommodationDetailsBasic,
                  ),
                }}
              ></p>
            </div>
          </Col>
        </Row>
      </div>

      <div className="border-bottom pb-24 mb-24">
        <h5>Kohteen lisätiedot</h5>
        <Row xs={1} xl={2} className="g-32">
          <Col>
            <FormLabel> FI</FormLabel>
            <div>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {getAccommodationTranslationItem(
                  "fi_FI",
                  "AccommodationDescriptionEnd",
                  accommodationDetailsBasic,
                )}
              </p>
            </div>
          </Col>
          <Col>
            <FormLabel>En</FormLabel>
            <div>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {getAccommodationTranslationItem(
                  "en_EN",
                  "AccommodationDescriptionEnd",
                  accommodationDetailsBasic,
                )}
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <div className="border-bottom pb-246 mb-24">
        <h5>Ajo-ohjeet</h5>
        <Row xs={1} xl={2} className="g-32">
          <Col>
            <FormLabel> FI</FormLabel>
            <div>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {getAccommodationTranslationItem(
                  "fi_FI",
                  "AccommodationDriveInstruction",
                  accommodationDetailsBasic,
                )}
              </p>
            </div>
          </Col>
          <Col>
            <FormLabel>En</FormLabel>
            <div>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {getAccommodationTranslationItem(
                  "en_EN",
                  "AccommodationDriveInstruction",
                  accommodationDetailsBasic,
                )}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AccommodationDesc;
export { AccommodationDesc };
